import React from 'react';
import { Select, Modal, notification } from 'antd';
import { injectIntl } from 'react-intl';
import { connect } from 'dva';
import { withRouter } from 'dva/router';
import styles from './styles.less';

const AccountSwitcher = ({ projects, currentProjectId, dispatch, intl }) => {
  let pId = currentProjectId;

  const switchAccount = (value) => {
    if (Number(value) !== pId) {
      Modal.confirm({
        title: intl.formatMessage({ id: 'Common.Attention' }),
        content: intl.formatMessage({
          id: 'Component.AccountSwitcher.Modal.Description',
        }, {
          accountName: projects.filter(p => p.id === Number(value))[0].name,
        }),
        onOk: () => {
          dispatch({
            type: 'app/selectProject',
            payload: {
              projectId: value,
            },
          }).then(() => {
            pId = value;
            notification.info({
              message: intl.formatMessage(
                { id: 'Component.AccountSwitcher.Switched' }),
            });
          });
        },
      });
    }
  };

  const options = projects.map(project => (
    <Select.Option disabled={project.disabled} value={project.id} key={project.id}>
      {project.name}
    </Select.Option>
  ));

  return (
    <Select
      className={styles.accountSwitcher}
      value={pId}
      key={currentProjectId}
      size="large"
      dropdownMatchSelectWidth={false}
      onSelect={switchAccount}
    >
      {options}
    </Select>
  );
};

export default withRouter(connect(({ app }) => ({
  projects: app.projects,
  currentProjectId: app.currentProjectId,
}))(injectIntl(AccountSwitcher)));



// WEBPACK FOOTER //
// ./src/components/AccountSwitcher/AccountSwitcher.js